<template>
	<v-dialog
		v-model="dialogNotificacion"
		persistent
		:max-width="isMobile ? '90%' : '30%'"
		style="z-index: 301"
	>
		<v-card>
			<v-card-title>{{ titulo }}</v-card-title>
			<v-card-text>
				<v-container class="fill-height">
					<v-row justify="center">
						<v-col cols="12" class="text-center">
							<v-icon size="120" :color="color">{{
								icono
							}}</v-icon>
						</v-col>
						<v-col cols="12" class="py-0">
							<p class="mb-0 text-center text-h6" v-html="textBody"></p>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-col cols="12">
					<v-row
						justify="center"
						class="align-center flex-wrap-reverse"
					>
						<v-col
							v-if="enableCancel"
							:cols="isMobile ? '12' : '6'"
							class="pt-0 order-1"
						>
							<v-btn
								color="primary"
								block
								@click="onClickCancelar()"
								>Cancelar</v-btn
							>
						</v-col>
						<v-col
							:cols="isMobile ? '12' : enableCancel ? '6' : '8'"
							class="pt-0 order-2"
							:class="{
								'd-flex align-center justify-center':
									!enableCancel,
							}"
						>
							<v-btn
								color="success"
								block
								@click="onClickAceptar()"
								>Aceptar</v-btn
							>
						</v-col>
					</v-row>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		isMobile: {
			type: Boolean,
			default: false,
		},
		enableCancel: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			icono: "mdi-check-circle",
			color: "primary",
			dialogNotificacion: false,
			titulo: null,
			textBody: null,
		};
	},
	methods: {
		onClickCancelar() {
			this.dialogNotificacion = false;
			this.$emit("click:cancelar");
			this.resetValues();
		},
		resetValues() {
			setTimeout(() => {
				this.titulo = null;
				this.textBody = null;
				this.icono = "mdi-check-circle";
				this.color = "primary";
			}, 200);
		},
		onClickAceptar() {
			this.dialogNotificacion = false;
			this.$emit("click:aceptar");
			this.resetValues();
		},
		showDialogNotificacion(titulo, textBody, icono, color) {
			this.titulo = titulo;
			this.textBody = textBody;
			this.icono = icono;
			this.color = color;

			this.dialogNotificacion = true;
		},
	},
};
</script>